module.exports = __webpack_public_path__ + "static/media/css2.cf1c5d02.png";